import React from "react";
import { BiLoaderCircle } from "react-icons/bi";
import styles from "./loading-icon.module.scss";

type Props = {
  size?: number;
};

const LoadingIcon = ({ size = 20 }: Props) => {
  return <BiLoaderCircle size={size} className={styles.loadingIcon} />;
};

export default LoadingIcon;
